import { render, staticRenderFns } from "./requotationOfDeliveryOrder.vue?vue&type=template&id=39834039&scoped=true&"
import script from "./requotationOfDeliveryOrder.vue?vue&type=script&lang=js&"
export * from "./requotationOfDeliveryOrder.vue?vue&type=script&lang=js&"
import style0 from "./requotationOfDeliveryOrder.vue?vue&type=style&index=0&id=39834039&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39834039",
  null
  
)

export default component.exports